import React, { Component, Suspense, useState } from "react";
const Header = React.lazy(() => import("../layout/header"))
const Footer = React.lazy(() => import("../layout/admin_footer"))


function AdminDashbord() {
    const [isReportAccess, setReportAccess] = useState(JSON.parse(localStorage.getItem('userPages')))

    if (localStorage.getItem("isLogedIn") === "null" || localStorage.getItem("isLogedIn") === null) {
        window.location.href = '/cms-login'
    }
    return (
        <div className='admin_dashboard_wrapr'>
            <Suspense fallback={<div></div>}>
                <Header />
                {/* <div className="container admin_dashboard_minheight">
                    <div className="admin_dashboard_outer">
                        <a href="/dashboard-list" className="dashboard_menu">View Reports</a>
                    </div>
                </div> */}
                <div className="container dashbrd_listheight">
                    <div className="breadcrumbs breadcrumbs_dashboard">
                        <ul>
                            <li>
                                <a href="/dashboard" class="breadcrumbLink">
                                    Dashboard
                                </a>
                            </li>
                            <div class="breadcrumbarrow-right" />
                            {/* <li>View Reports</li> */}
                        </ul>
                    </div>
                    <div className="admin_dashboard_outer">
                        {(isReportAccess.filter((obj)=>obj.projectPagesId === 2).length > 0 || localStorage.getItem('role') === "SuperAdmin") &&
                            <a href="/centerList" className="dashboard_menu">Manage Campaign Form - Centre Listing</a>
                        }
                        {(isReportAccess.filter((obj)=>obj.projectPagesId === 3).length > 0 || localStorage.getItem('role') === "SuperAdmin") &&
                            <a href="/contact_report" className="dashboard_menu">View Reports  -  Student Enquiry</a>
                        }
                        {(localStorage.getItem('role') === "SuperAdmin") &&
                        <a href="/userList" className="dashboard_menu">User List</a>
                        }
                    </div>
                </div>
                <Footer />
            </Suspense>    </div>
    )
}
export default AdminDashbord